// src/utils/chatUtils.js

/**
 * Genera un ID único para el chat entre dos usuarios,
 * asegurando que el orden no afecte el resultado.
 *
 * @param {string} uid1 - UID del primer usuario.
 * @param {string} uid2 - UID del segundo usuario.
 * @returns {string} ID único para el chat.
 */
export const getChatId = (uid1, uid2) => {
  return [uid1, uid2].sort().join('_');
};
